import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_layout_1m+5",
  "use": "icon-icon_layout_1m+5-usage",
  "viewBox": "0 0 60 45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 60 45\" id=\"icon-icon_layout_1m+5\">\n<path d=\"M0,0v45h60V0H0z M1,1h38.3v28.3H1V1z M1,44V30.3h18.7V44H1z M20.7,44V30.3h18.7V44H20.7z M59,44H40.3V30.3H59V44z M59,29.3\n\tH40.3V15.7H59V29.3z M59,14.7H40.3V1H59V14.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol